// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetDealerResults = () => ({
    type: actions.RESET_DEALER_SEARCH_RESULTS
});




// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/reset-dealer-results.js